/**
 * @file The CommentsService communicates with the comments backend.
 * @author Tzi Yang Lum
 */
import * as tslib_1 from "tslib";
import { AlertsService } from '../core/alerts.service';
import { BreezeService } from '../core/breeze.service';
import { TranslateService } from '@ngx-translate/core';
import { DataSet } from '../core/helpers/data-set';
import { EntityManagerService } from '../entity-manager.service';
import { DomainService } from '../domain.service';
/**
 * The CommentsService communicates with the comments backend.
 * @export
 * @class CommentService
 * @extends {BreezeService}
 */
var CommentService = /** @class */ (function (_super) {
    tslib_1.__extends(CommentService, _super);
    /**
     * Constructs a CommentService
     */
    function CommentService(alertsService, translateService, entityManagerService, domainService) {
        var _this = _super.call(this, alertsService, translateService, entityManagerService) || this;
        _this.domainService = domainService;
        _this.initialize('comments');
        return _this;
    }
    /**
     * Create comment
     * @param itemOid
     * @param comment
     * @param user
     */
    CommentService.prototype.createComment = function (itemOid, comment, user) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var object, entityType, entity;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                object = {
                    'Entity_Oid': itemOid,
                    'User': user.user['Oid'],
                    'ResourceOid': user.resourceOid,
                    'Value': comment,
                    'IsDeletedAt': null
                };
                entityType = this.getEntityType('Comment');
                entity = entityType.createEntity(object);
                this.addEntity(entity);
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        return _this.saveChanges(function (error) {
                            if (error) {
                                _this.rejectChanges();
                                reject(error);
                            }
                            else {
                                resolve('APP.SOCIAL.COMMENT_SUCCESSFULLY_ADDED');
                            }
                        });
                    })];
            });
        });
    };
    /**
     * Get all comments
     * @param itemOid
     */
    CommentService.prototype.getComments = function (itemOid) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var entityType, dataSet, queryResult, entities, comments, _i, entities_1, entity, user, comment;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        entityType = this.getEntityType('Comment');
                        dataSet = new DataSet(this);
                        dataSet.entityType = entityType;
                        dataSet.sourceName = 'CommentItems';
                        return [4 /*yield*/, dataSet.refresh()];
                    case 1:
                        queryResult = _a.sent();
                        entities = queryResult.results.filter(function (value) { return value['Entity_Oid'] === itemOid; });
                        comments = [];
                        _i = 0, entities_1 = entities;
                        _a.label = 2;
                    case 2:
                        if (!(_i < entities_1.length)) return [3 /*break*/, 5];
                        entity = entities_1[_i];
                        return [4 /*yield*/, this.getUser(entity['User'])];
                    case 3:
                        user = _a.sent();
                        comment = {
                            entityAspect: entity.entityAspect,
                            entityType: entity.entityType,
                            id: entity['Id'],
                            entityOid: entity['Entity_Oid'],
                            userOid: entity['User'],
                            user: user,
                            resourceOid: entity['ResourceOid'],
                            created: entity['IsCreatedAt'],
                            comment: entity['Value'],
                            isDeletedAt: entity['IsDeletedAt']
                        };
                        comments.push(comment);
                        _a.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5: return [2 /*return*/, comments];
                }
            });
        });
    };
    /**
     * Remove comment from id
     * @param itemId
     */
    CommentService.prototype.removeComment = function (itemId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var entityType, dataSet, date, queryResult, item;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        entityType = this.getEntityType('Comment');
                        dataSet = new DataSet(this);
                        dataSet.entityType = entityType;
                        dataSet.sourceName = 'CommentItems';
                        date = new Date();
                        return [4 /*yield*/, dataSet.refresh()];
                    case 1:
                        queryResult = _a.sent();
                        item = queryResult.results.find(function (value) { return value['Id'] === itemId; });
                        // The backend will set this to service date
                        item['IsDeletedAt'] = date;
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                return _this.saveChanges(function (error) {
                                    if (error) {
                                        _this.rejectChanges();
                                        reject(error);
                                    }
                                    else {
                                        resolve('APP.SOCIAL.COMMENT_SUCCESSFULLY_DELETED');
                                    }
                                });
                            })];
                }
            });
        });
    };
    CommentService.prototype.getUser = function (oid) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var entityType, user;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        entityType = this.domainService.getEntityType('User');
                        return [4 /*yield*/, this.domainService.getEntityByKey(entityType, oid).toPromise()];
                    case 1:
                        user = _a.sent();
                        return [2 /*return*/, user];
                }
            });
        });
    };
    return CommentService;
}(BreezeService));
export { CommentService };
